import './MultiFilter.css';
import React from 'react';
import IconChevronDown from '../../resources/icons/IconChevronDown.svg';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { removeQueryString } from '../Listing';
import { useHistory } from 'react-router-dom';
import { mobileCheck } from "../../utils";
const compareArray = (arr1, arr2) => {
  return arr1.length === arr2.length && arr1.every(element => arr2.includes(element));
};
const MultiFilter = _ref => {
  let {
    setFilterDropdownState,
    setFilterMultipleChoicesState,
    resetFilterChoiceState,
    items,
    filters,
    isOpen,
    label,
    filterName,
    resultsAmount,
    clearAllLabel,
    showNResultsLabel,
    formattedItems,
    fitlersValueAnalytics,
    filtersShowResultsAnalytics,
    params,
    fitlersCategoryAnalytics,
    fitlersClearAnalytics
  } = _ref;
  const [stateFilters, setStateFilters] = React.useState(filters);
  const [appliedFiltersLabel, setAppliedFiltersLabel] = React.useState(label);
  const [appliedFormattedLabel, setAppliedFormattedLabel] = React.useState([]);
  let history = useHistory();
  const checkedOptions = React.useRef(filters);
  React.useEffect(() => {
    setStateFilters(filters);
    if (!filters || !filters.length) {
      setAppliedFiltersLabel(label);
      setAppliedFormattedLabel([]);
      checkedOptions.current = [];
    }
  }, [filters]);
  React.useEffect(() => {
    if (mobileCheck() && !compareArray(stateFilters, filters)) {
      setFilterMultipleChoicesState(stateFilters, filterName, true);
    }
  }, [stateFilters]);
  React.useEffect(() => {
    if (stateFilters.length) {
      const tmpArr = [];
      filterItems.forEach(_ref2 => {
        let {
          key,
          label
        } = _ref2;
        if (stateFilters.includes(key)) {
          tmpArr.push(label);
        }
      });
      setAppliedFormattedLabel(tmpArr);
      setAppliedFiltersLabel(tmpArr.join(', '));
    } else {
      setAppliedFormattedLabel([]);
      setAppliedFiltersLabel(label);
    }
  }, []);

  // Open/Close popup
  const toggleFilter = e => {
    setFilterDropdownState(!isOpen, filterName);
    e.preventDefault();
  };
  const submitFilters = e => {
    setFilterMultipleChoicesState(stateFilters, filterName);
    setFilterDropdownState(false, filterName);
    e.preventDefault();
  };
  const clearFilter = e => {
    resetFilterChoiceState(filterName);
    removeQueryString(filterName, history);
    setAppliedFiltersLabel(label);
    setAppliedFormattedLabel([]);
    checkedOptions.current = [];
    e.preventDefault();
  };
  const itemToggle = e => {
    const value = e.currentTarget.value;
    const add = e.currentTarget.checked;
    const items = [...stateFilters];
    const index = items.findIndex(item => item === value);
    index > -1 && !add ? items.splice(index, 1) : add && items.push(value);
    setStateFilters(items);
  };
  let filterItems = formattedItems;
  if (!filterItems) {
    if (items) {
      filterItems = Object.keys(items).map(k => {
        return {
          key: k,
          label: k
        };
      });
    }
  }
  if (!filterItems) {
    console.warn('filter setup is incorrect');
    return null;
  }

  // If you check some facet - recalculate amount of results to be shown.
  const amountToBeShown = stateFilters.length ? Object.keys(items).reduce((amount, key) => {
    if (stateFilters.includes(key)) {
      return amount + items[key];
    }
    return amount;
  }, 0) : resultsAmount;
  const filterLabel = label;
  const setTemporaryLabelOnChange = e => {
    const currentName = e.target.value;
    if (!checkedOptions.current.includes(currentName)) {
      checkedOptions.current = [...checkedOptions.current, currentName];
    } else {
      checkedOptions.current.splice(checkedOptions.current.indexOf(currentName), 1);
    }
    setStateFilters(() => checkedOptions.current);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field"
  }, /*#__PURE__*/React.createElement("div", {
    className: `filter-panel eloqua ${isOpen ? 'filter-panel--open' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: `filter-panel__box ${isOpen ? 'filter-panel__box--openedDrop' : ''}`
  }, /*#__PURE__*/React.createElement("a", {
    className: "filter-panel__trigger js-filter-panel__trigger",
    href: "/#",
    "aria-label": "Select fitlers Category",
    onClick: e => {
      tealiumClickFunc(tealiumMergeClickData(fitlersCategoryAnalytics, params), label);
      toggleFilter(e);
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, checkedOptions.current.length !== 0 ? checkedOptions.current.toString() : label), /*#__PURE__*/React.createElement("img", {
    className: "icon",
    src: IconChevronDown,
    alt: "smth"
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fp__inner-cb"
  }, /*#__PURE__*/React.createElement("a", {
    className: "body-medium fp__inner-clear",
    href: "/#",
    tabIndex: 0,
    "aria-label": "Clear fitlers",
    onClick: e => {
      tealiumClickFunc(tealiumMergeClickData(fitlersClearAnalytics, params));
      clearFilter(e);
    }
  }, clearAllLabel)), filterItems.map(item => {
    const {
      key,
      label
    } = item;
    return /*#__PURE__*/React.createElement("label", {
      tabIndex: 0,
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.click();
        }
      },
      className: `checkbox-aligned fp__inner-label ${customCheckboxCss}`,
      htmlFor: key.replace(/\s/g, '_'),
      key: key
    }, /*#__PURE__*/React.createElement("input", {
      checked: stateFilters.includes(key),
      className: "input-choice fp__checkbox",
      type: "checkbox",
      name: filterName,
      value: key,
      id: key.replace(/\s/g, '_'),
      onChange: e => {
        tealiumClickFunc(tealiumMergeClickData(fitlersValueAnalytics, params), [filterLabel, label]);
        itemToggle(e);
        if (e.target.checked) {
          setAppliedFormattedLabel([...appliedFormattedLabel, label]);
        } else {
          setAppliedFormattedLabel(appliedFormattedLabel.filter(item => item !== label));
        }
        setTemporaryLabelOnChange(e);
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: 'fp__checkbox-label'
    }), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-text"
    }, label, " (", items[key], ")"), /*#__PURE__*/React.createElement("span", {
      className: "fp__inner-label-bg"
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    tabIndex: 0,
    onClick: e => {
      tealiumClickFunc(tealiumMergeClickData(filtersShowResultsAnalytics, params), filterLabel);
      submitFilters(e);
      setAppliedFiltersLabel(appliedFormattedLabel.length ? appliedFormattedLabel.join(', ') : label);
    }
  }, showNResultsLabel.replace('{#resultsAmount#}', '')))))));
};
const customCheckboxCss = "cfrjp5s";
export default MultiFilter;